import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-confirm-dialog-common",
  templateUrl: "./confirm-dialog-common.component.html",
  styleUrl: "./confirm-dialog-common.component.scss",
})
export class ConfirmDialogCommonComponent {
  @Input() confirmDialogContent: any = {};
  @Output() confirmDialogActionCall = new EventEmitter<any>();

  ngOnInit(): void {}

  alertBtnAction(btnFlag: boolean = false) {
    let data = {
      dialogkey: this.confirmDialogContent.dialogkey,
      actionValue: btnFlag,
    };
    this.confirmDialogActionCall.emit(data);
  }
}
